var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconMetamask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#FFDEC0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6113 4.80029L12.9355 8.99995L13.991 6.52496L18.6113 4.80029Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.51562 4.80029L11.1409 9.03915L10.136 6.52495L5.51562 4.80029Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5707 14.5381L15.0605 16.8451L18.2942 17.7354L19.2205 14.5885L16.5707 14.5381Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.91211 14.5885L5.8328 17.7354L9.06086 16.8451L7.5563 14.5381L4.91211 14.5885Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.89822 10.6408L8 11.9959L11.2 12.1415L11.0933 8.69775L8.89822 10.6408Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2373 10.6409L13.0085 8.65869L12.9355 12.1416L16.1355 11.996L15.2373 10.6409Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07422 16.845L11.011 15.9099L9.3437 14.6108L9.07422 16.845Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.123 15.9099L15.0542 16.845L14.7904 14.6108L13.123 15.9099Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0542 16.8448L13.123 15.9097L13.2802 17.164L13.2634 17.6959L15.0542 16.8448Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07422 16.8448L10.8707 17.6959L10.8595 17.164L11.011 15.9097L9.07422 16.8448Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9005 13.7816L9.29492 13.3113L10.4289 12.7905L10.9005 13.7816Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2266 13.7816L13.6982 12.7905L14.8378 13.3113L13.2266 13.7816Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.06508 16.8451L9.3458 14.5381L7.56055 14.5885L9.06508 16.8451Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7832 14.5381L15.0583 16.8451L16.5685 14.5885L14.7832 14.5381Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1355 11.9961L12.9355 12.1417L13.2331 13.7824L13.7047 12.7912L14.8443 13.312L16.1355 11.9961Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29683 13.312L10.4308 12.7912L10.9024 13.7824L11.2 12.1417L8 11.9961L9.29683 13.312Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.9961L9.34175 14.6111L9.29681 13.312L8 11.9961Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8435 13.312L14.793 14.6111L16.1347 11.9961L14.8435 13.312Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1941 12.1416L10.8965 13.7823L11.2726 15.7197L11.3568 13.1663L11.1941 12.1416Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9346 12.1416L12.7773 13.1608L12.8559 15.7197L13.2321 13.7823L12.9346 12.1416Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2336 13.7814L12.8574 15.7188L13.1269 15.9092L14.7943 14.6101L14.8448 13.311L13.2336 13.7814Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M9.29492 13.311L9.33986 14.6101L11.0072 15.9092L11.2767 15.7188L10.9005 13.7814L9.29492 13.311Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2735 17.6959L13.2903 17.1639L13.1444 17.0407H10.9998L10.8595 17.1639L10.8707 17.6959L9.07422 16.8447L9.70298 17.3599L10.9774 18.239H13.1612L14.4412 17.3599L15.0643 16.8447L13.2735 17.6959Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1194 15.9096L12.8499 15.7192H11.2667L10.9973 15.9096L10.8457 17.1639L10.9861 17.0407H13.1306L13.2766 17.1639L13.1194 15.9096Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8493 9.27432L19.3265 6.95612L18.6079 4.80029L13.123 8.85998L15.2339 10.6406L18.2149 11.5086L18.8718 10.7414L18.5855 10.5342L19.0402 10.1199L18.6921 9.85109L19.1469 9.50391L18.8493 9.27432Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M4.79883 6.95612L5.28163 9.27432L4.97286 9.50391L5.43321 9.85109L5.08514 10.1199L5.53987 10.5342L5.25356 10.7414L5.9104 11.5086L8.89145 10.6406L11.0023 8.85998L5.51742 4.80029L4.79883 6.95612Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2175 11.509L15.2365 10.6411L16.1347 11.9962L14.793 14.6112L16.567 14.5888H19.2168L18.2175 11.509Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88679 10.6411L5.90578 11.509L4.91211 14.5888H7.5563L9.3303 14.6112L7.98857 11.9962L8.88679 10.6411Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9286 12.1413L13.1195 8.85989L13.984 6.5249H10.1328L10.9974 8.85989L11.1882 12.1413L11.2612 13.1716L11.2668 15.7194H12.85L12.8556 13.1716L12.9286 12.1413Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMetamask);
export default __webpack_public_path__ + "static/media/icon-metamask.46e2c39c362e87188c67dde6707f18a9.svg";
export { ForwardRef as ReactComponent };